export const getMinutesAndSeconds = (count: number) => {
    const minutes = Math.floor(count / 60) - (Math.floor(count / 60 / 60) * 60);
    const seconds = count % 60;

    return {
        minutes, seconds,
    };
};
